import React from 'react'

function Bonus() {
  const bonuses = [
    {
      title: 'Cafés da manhã deliciosos durante toda a semana',
      desc: '30 receitas rápidas para começar o dia com energia, sem glúten e sem açúcar.',
      img: 'https://static.lumi.new/96/96452420f056634c2c6405e1d94b6338.png',
      price: 'R$ 47,00',
    },
    {
      title: 'Doces incríveis sem culpa',
      desc: 'Sobremesas irresistíveis, adoçadas naturalmente, para toda a família.',
      img: 'https://static.lumi.new/96/96452420f056634c2c6405e1d94b6338.png',
      price: 'R$ 47,00',
    },
    {
      title: 'Massas perfeitas mesmo para iniciantes',
      desc: 'Fundamentos de massas, farinhas e fermentos para nunca mais errar uma receita.',
      img: 'https://static.lumi.new/b3/b3ce0645c7ef01668c423c6f5cfa06e2.png',
      price: 'R$ 37,00',
    },
  ]

  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm mb-3">Bônus exclusivos</p>
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Você também recebe, sem custo
          </h2>
        </div>

        <div className="space-y-6">
          {bonuses.map((b, i) => (
            <div
              key={i}
              className="relative bg-white rounded-[20px] border border-[#EBD9C3] p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 shadow-sm hover:shadow-lg transition-shadow duration-300 animate-fade-up"
            >
              <span className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-[#D9891B] text-white text-[11px] font-bold uppercase tracking-wide shadow-md">Bônus Exclusivo</span>
              <div className="w-full md:w-40 h-40 rounded-[20px] overflow-hidden flex-shrink-0 bg-[#EBD9C3] flex items-center justify-center shadow-md">
                <img
                  src={b.img}
                  alt={b.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="font-display text-xl font-bold text-[#49352B] mb-2">{b.title}</h3>
                <p className="text-[#49352B]/70 text-sm leading-relaxed">{b.desc}</p>
              </div>
              <div className="text-center flex-shrink-0">
                <p className="text-[#49352B]/40 line-through text-lg">{b.price}</p>
                <p className="inline-block px-3 py-1 rounded-full bg-[#5E774B]/10 text-[#5E774B] font-bold text-xl">GRÁTIS</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Bonus
